// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import * as _ from "lodash";

export const environment = {
    production: false,
    // Dev fallback for the new (Blazor) app — used for local (non-fbolinx) hosts only;
    // deployed environments derive the URL from the request host (NewDesignUrlService).
    newDesignUrl: 'https://localhost:7286',
    mapbox: {
        accessToken: 'pk.eyJ1IjoiZnVlbGVybGlueCIsImEiOiJja3NzODNqcG4wdHVrMm9rdHU3OGRpb2dmIn0.LvSvlGG0ej3PEDJOBpOoMQ'
    },
    flightWatch: {
        apiCallInterval: 5000,
        _1200aeroUrl: 'https://dfbolinx.1200.aero'
    },
    hostNames: {
        support : 'localhost',
        base: 'localhost'
    }
    
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
